import React from "react";
import { useNavigate } from "react-router-dom";
import { Form, Input, Select, Button } from "antd";
import { ArrowLeftOutlined, ArrowRightOutlined } from "@ant-design/icons";
import styled from "@emotion/styled";
import { Row } from "components/lib";
import {Employer} from "../../employer/employer-list/list";

const { Option } = Select;

interface TopBarDat extends Partial<Employer>{
  isLoading?: boolean;
}

export const TopBar = (props: TopBarDat) => {
  const navigate = useNavigate();

  return (
    <Container>
      <FixedBar between={true}>
        <BarLeft gap={true}>
          <ArrowLeftOutlined onClick={() => navigate(-1)} />
          <Title>創建工作</Title>
        </BarLeft>
        <BarRight>
          <Form.Item>
            <Button type="primary" htmlType="submit" loading={props.isLoading}>
              確定創建
              <ArrowRightOutlined />
            </Button>
          </Form.Item>
        </BarRight>
      </FixedBar>
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 80px;
  padding: 28px 32px;
  background-color: #ffffff;
  position: sticky;
  top: 0px;
  z-index: 999;
`;

const FixedBar = styled(Row)`
  z-index: 1;
`;
const BarLeft = styled(Row)``;
const BarRight = styled(Row)``;

const Title = styled.div`
  color: #3c3e42;
  font-size: 20px;
  font-weight: bold;
`;
